import * as React from "react";
import { Box } from "@mui/material";
import FilterComponent from "../../../ReusableFIlterComponent/FilterComponent";
import { AdvisorGapRule } from "../helpers/advisorStaticData";

const SELECTED_COLOR = "#9C27B0";
const UNSELECTED_COLOR = "#000000DE";

interface Props {
  /** the unfiltered rules - the filter options are derived from them */
  gapRulesData: AdvisorGapRule[];
  selectedTargetField: string[];
  setSelectedTargetField: (updatedSelection: string[]) => void;
  selectedDestinationTable: string[];
  setSelectedDestinationTable: (updatedSelection: string[]) => void;
  selectedStatus: string[];
  setSelectedStatus: (updatedSelection: string[]) => void;
  /** clears whatever the parent holds outside these three filters */
  onClearFilters: () => void;
}

export const AdvisorGapRulesFilterItems = ({
  gapRulesData,
  selectedTargetField,
  setSelectedTargetField,
  selectedDestinationTable,
  setSelectedDestinationTable,
  selectedStatus,
  setSelectedStatus,
  onClearFilters,
}: Props) => {
  // the popup search boxes are internal to the filters, so they live here
  const [searchTargetField, setSearchTargetField] = React.useState("");
  const [searchDestinationTable, setSearchDestinationTable] =
    React.useState("");

  const filterConfig = [
    {
      key: "target_field",
      name: "Target Field",
      label: "Select a Target Field",
      searchTerm: searchTargetField,
      onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) =>
        setSearchTargetField(event.target.value),
      selectedOption: selectedTargetField,
      filterName: "target_field",
      data: gapRulesData,
      onSelectionChange: (updatedSelection: any) =>
        setSelectedTargetField(updatedSelection),
      count: selectedTargetField.length,
      colorSelected:
        selectedTargetField.length > 0 ? SELECTED_COLOR : UNSELECTED_COLOR,
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "destination_table",
      name: "Destination Table",
      label: "Select a Destination Table",
      searchTerm: searchDestinationTable,
      onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) =>
        setSearchDestinationTable(event.target.value),
      selectedOption: selectedDestinationTable,
      filterName: "destination_table",
      data: gapRulesData,
      onSelectionChange: (updatedSelection: any) =>
        setSelectedDestinationTable(updatedSelection),
      count: selectedDestinationTable.length,
      colorSelected:
        selectedDestinationTable.length > 0
          ? SELECTED_COLOR
          : UNSELECTED_COLOR,
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "status",
      name: "Status",
      label: "Select a Status",
      selectedOption: selectedStatus,
      filterName: "is_active",
      data: gapRulesData,
      onSelectionChange: (updatedSelection: any) =>
        setSelectedStatus(updatedSelection),
      count: selectedStatus.length,
      colorSelected:
        selectedStatus.length > 0 ? SELECTED_COLOR : UNSELECTED_COLOR,
      multiSelect: true,
      // is_active is a boolean, so the two states are spelled out here rather
      // than derived from the data as "true"/"false"
      options: [
        { label: "Active", value: "true" },
        { label: "Inactive", value: "false" },
      ],
    },
  ];

  const clearFilters = () => {
    setSearchTargetField("");
    setSearchDestinationTable("");
    setSelectedTargetField([]);
    setSelectedDestinationTable([]);
    setSelectedStatus([]);
    onClearFilters();
  };

  return (
    <Box>
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
        filterNameURL="gapRulesFilters"
        paginationKey="gapRulesPage"
      />
    </Box>
  );
};

export default AdvisorGapRulesFilterItems;
